import { buildProps as r } from "./index601.js";
const p = r({
  arrowOffset: {
    type: Number,
    default: 5
  }
});
export {
  p as popperArrowProps
};
